var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18C13.9587 18 15.3576 17.4205 16.3891 16.3891C17.4205 15.3576 18 13.9587 18 12.5C18 11.0413 17.4205 9.64236 16.3891 8.61091C15.3576 7.57946 13.9587 7 12.5 7C11.0413 7 9.64236 7.57946 8.61091 8.61091C7.57946 9.64236 7 11.0413 7 12.5C7 13.9587 7.57946 15.3576 8.61091 16.3891C9.64236 17.4205 11.0413 18 12.5 18Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 1H6.75C5.22501 1 3.76247 1.6058 2.68414 2.68414C1.6058 3.76247 1 5.22501 1 6.75V18.25C1 19.775 1.6058 21.2375 2.68414 22.3159C3.76247 23.3942 5.22501 24 6.75 24H18.25C19.775 24 21.2375 23.3942 22.3159 22.3159C23.3942 21.2375 24 19.775 24 18.25V6.75C24 5.22501 23.3942 3.76247 22.3159 2.68414C21.2375 1.6058 19.775 1 18.25 1Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 6.75C19.4969 6.75 19.3141 6.67427 19.1793 6.53948C19.0445 6.40469 18.9688 6.22187 18.9688 6.03125C18.9688 5.84063 19.0445 5.65781 19.1793 5.52302C19.3141 5.38823 19.4969 5.3125 19.6875 5.3125",
    stroke: "white",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 6.75C19.8781 6.75 20.0609 6.67427 20.1957 6.53948C20.3305 6.40469 20.4062 6.22187 20.4062 6.03125C20.4062 5.84063 20.3305 5.65781 20.1957 5.52302C20.0609 5.38823 19.8781 5.3125 19.6875 5.3125",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e120f4a62644b3ff669e4201b4a3ca59.svg";
export { ForwardRef as ReactComponent };